import { CreateListEmployeeVehicle, UploadEmployeeVehicleFormFile } from "../../../reduxToolkit/Files/FilesApi"; // Import API actions for uploading vehicle files and creating vehicle records
import { toast } from "react-toastify"; // Import toast notifications for user feedback
import routes from "../../../Routes/routes";
import {errorMsg} from "../../../Apis/functions"; // Import app routes for navigation

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

// This component handles file upload and creation of employee vehicle records,
// managing upload validation and success/error notifications
export const CreationErrorsVehicleApp = ({
                                             t,               // Translation function for localization
                                             dispatch,        // Redux dispatch function to send actions
                                             navigate,        // Function to navigate between routes
                                             spreadsheetData, // Data of the uploaded spreadsheet file
                                             data,            // Processed data ready to be submitted for creation
                                             setUpdate,       // State setter to indicate update/loading status
                                             getFormData,     // Function to retrieve form data (e.g., the file as FormData)
                                             isValidFile      // Callback function to validate the uploaded file data
                                         }) => {

    // Function to handle uploading the vehicle spreadsheet file
    const handleUploadFile = () => {
        setUpdate(true); // Set the update/loading state to true

        if (spreadsheetData) { // Check if there is spreadsheet data to upload
            let data = getFormData(); // Get the form data (file) for upload

            if (data) {
                // Dispatch the upload action with the form data
                dispatch(UploadEmployeeVehicleFormFile(data))
                    .then(({ payload: { data, success } }) => {
                        if (success === true) {
                            // If upload succeeds, validate the file data
                            isValidFile(data);
                        }
                    })
                    .catch(() => {
                        // Show error toast if upload fails
                        toast.error(t('fail_to_upload_file').toUpperCase());
                    });
            }
        } else {
            // Warn user if no file is available to upload
            toast?.warn(t('there_is_not_file_to_upload').toUpperCase());
        }
    };

    // Function to confirm and create the employee vehicle records using processed data
    const handleConfirm = () => {
        dispatch(CreateListEmployeeVehicle(data)).then(({ payload: { data: { success, code } } }) => {
            if (success === true) {
                // Notify success and navigate to the vehicle fleet list page
                toast.success(t('has_been_created_successfully'));
                navigate(routes.vehicleFleet.list);
            } else errorMsg(code)
        });
    };

    // Return handlers to be used in the UI component
    return {
        handleConfirm,
        handleUploadFile,
    };
};

// Export this logic container for use in other parts of the app
export default CreationErrorsVehicleApp;
